<template>
    <div>
        <hr />
        <div class="field-container">
            <h2>Tertiary Attack</h2>
            <div class="field full">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="attack.tertiary.hasTertiary" @change="updateHasTertiary">
                    Has Tertiary Attack?
                </label>
            </div>
        </div>
        <div v-if="attack.tertiary.hasTertiary">
            <div class="field-container">
                <div class="field quarter">
                    <label for="" class="label">Attack Bonus Type</label>
                    <div class="select">
                        <select name="" id="" :value="attack.tertiary.bonusSource" @change="updateTertiaryAttackBonusSource">
                            <option value="weapon">Weapon</option>
                            <option value="implement">Implement</option>
                            <option value="statandbonus">Stat + Static Bonus</option>
                            <option value="static">Static Bonus</option>
                        </select>
                    </div>
                </div>
                <div class="field quarter" v-if="attack.tertiary.bonusSource != 'static'">
                    <label for="" class="label">Attack Stat</label>
                    <div class="select">
                        <select name="" id="" :value="attack.tertiary.stat" @change="updateTertiaryStat">
                            <option value="Strength">Strength</option>
                            <option value="Dexterity">Dexterity</option>
                            <option value="Constitution">Constitution</option>
                            <option value="Intelligence">Intelligence</option>
                            <option value="Wisdom">Wisdom</option>
                            <option value="Charisma">Charisma</option>
                        </select>
                    </div>
                </div>
                <div class="field quarter" v-if="isWeaponOrImplement">
                    <label for="" class="label">Weapon/Implement #</label>
                    <input type="text" class="input" :value="attack.tertiary.weaponNumber" @input="updateTertiaryWeaponNumber">
                </div>
                <div class="field quarter">
                    <label for="" class="label">Crit on</label>
                    <input type="number" class="input" :value="attack.tertiary.critRange" @input="updateTertiaryCritRange">
                </div>
            </div>
            <div class="field-container">
                <div class="field">
                    <label for="" class="label">Target</label>
                    <input type="text" class="input" :value="attack.tertiary.target" @input="updateTertiaryTarget">
                </div>
                <div class="field quarter">
                    <label for="" class="label">Defense</label>
                    <div class="select">
                        <select name="" id="" :value="attack.tertiary.defense" @change="updateTertiaryDefense">
                            <option value="AC">AC</option>
                            <option value="Fort">Fort</option>
                            <option value="Ref">Ref</option>
                            <option value="Will">Will</option>
                        </select>
                    </div>
                </div>
                <div class="field quarter">
                    <label for="" class="label">Static Attack Bonus</label>
                    <input type="text" class="input" :value="attack.tertiary.staticBonus" @input="updateTertiaryStaticBonus">
                </div>
            </div>
            <div class="field-container">
                <div class="field quarter">
                    <label for="" class="checkbox">
                        <input type="checkbox" :checked="damage.tertiary.hasDamage" @change="updateTertiaryHasDamage">
                        Has Damage?
                    </label>
                </div>
                <div class="field quarter" v-if="damage.tertiary.hasDamage">
                    <label for="" class="checkbox">
                        <input type="checkbox" :checked="damage.tertiary.addStatMod" @change="updateTertiaryAddStatMod">
                        Add Stat Mod?
                    </label>
                </div>
                <div class="field quarter" v-if="damage.tertiary.hasDamage">
                    <label for="" class="checkbox">
                        <input type="checkbox" :checked="damage.tertiary.isBrutal" @change="updateTertiaryIsBrutal">
                        Reroll Less than X (Brutal)?
                    </label>
                </div>
            </div>
            <div class="field-container" v-if="damage.tertiary.hasDamage">
                <div class="field quarter">
                    <label for="" class="label">Dice/[W] Quantity</label>
                    <input type="text" class="input" :value="damage.tertiary.diceQuantity" @input="updateTertiaryDiceQuantity">
                </div>
                <div class="field quarter" v-if="attack.tertiary.bonusSource != 'weapon'">
                    <label for="" class="label">Dice Sides</label>
                    <input type="text" class="input" :value="damage.tertiary.diceSides" @input="updateTertiaryDiceSides">
                </div>
                <div class="field quarter">
                    <label for="" class="label">Static Damage Bonus</label>
                    <input type="text" class="input" :value="damage.tertiary.staticBonus" @input="updateTertiaryStaticDamageBonus">
                </div>
                <div class="field quarter">
                    <label for="" class="label">Damage Type</label>
                    <input type="text" class="input" :value="damage.tertiary.type" @input="updateTertiaryType">
                </div>
                <div class="field quarter" v-if="damage.tertiary.isBrutal">
                    <label for="" class="label">Brutal Value</label>
                    <input type="text" class="input" :value="damage.tertiary.brutalValue" @input="updateTertiaryBrutalValue">
                </div>
            </div>
            <div class="field-container">
                <div class="field full">
                    <label for="" class="label">Hit Effect</label>
                    <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.tertiary.hitEffect" @input="updateTertiaryHitEffect"></textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {

    },
    components: {

    },
    data: function() {
        return {

        };
    },
    computed: {
        ...mapState({
            attack: state => state.attack,
            damage: state => state.damage,
        }),
        isWeaponOrImplement() {
            return this.attack.tertiary.bonusSource == 'weapon' || this.attack.tertiary.bonusSource == 'implement';
        },
    },
    methods: {
        // attack
        updateHasTertiary(e) {
            this.$store.commit('attack/setHasTertiary', e.target.checked);
        },
        updateTertiaryAttackBonusSource(e) {
            this.$store.commit('attack/setTertiaryBonusSource', e.target.value);
        },
        updateTertiaryStat(e) {
            this.$store.commit('attack/setTertiaryStat', e.target.value);
        },
        updateTertiaryWeaponNumber(e) {
            this.$store.commit('attack/setTertiaryWeaponNumber', e.target.value);
        },
        updateTertiaryStaticBonus(e) {
            this.$store.commit('attack/setTertiaryStaticBonus', e.target.value);
        },
        updateTertiaryCritRange(e) {
            this.$store.commit('attack/setTertiaryCritRange', e.target.value);
        },
        updateTertiaryTarget(e) {
            this.$store.commit('attack/setTertiaryTarget', e.target.value);
        },
        updateTertiaryDefense(e) {
            this.$store.commit('attack/setTertiaryDefense', e.target.value);
        },
        updateTertiaryHitEffect(e) {
            this.$store.commit('attack/setTertiaryHitEffect', e.target.value);
        },
        // damage
        updateTertiaryDiceQuantity(e) {
            this.$store.commit('damage/setTertiaryDiceQuantity', e.target.value);
        },
        updateTertiaryDiceSides(e) {
            this.$store.commit('damage/setTertiaryDiceSides', e.target.value);
        },
        updateTertiaryStaticDamageBonus(e) {
            this.$store.commit('damage/setTertiaryStaticBonus', e.target.value);
        },
        updateTertiaryAddStatMod(e) {
            this.$store.commit('damage/setTertiaryAddStatMod', e.target.checked);
        },
        updateTertiaryHasDamage(e) {
            this.$store.commit('damage/setTertiaryHasDamage', e.target.checked);
        },
        updateTertiaryType(e) {
            this.$store.commit('damage/setTertiaryType', e.target.value);
        },
        updateTertiaryIsBrutal(e) {
            this.$store.commit('damage/setTertiaryIsBrutal', e.target.checked);
        },
        updateTertiaryBrutalValue(e) {
            this.$store.commit('damage/setTertiaryBrutalValue', e.target.value);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
